import { AbstractRealtimeComponent } from '../../abstract-realtime-component';
export default class ServerDoctorRealtimeComponent extends AbstractRealtimeComponent {
    /* @ngInject */
    constructor($rootScope) {
        super();
        this.$rootScope = $rootScope;
    }
    create() {
        return this;
    }
    onMessage(message) {
        switch (message.action) {
            case 'phoneConfirmation': {
                this.phoneConfirmation(message);
                break;
            }
            case 'passwordChanged': {
                this.passwordChanged(message);
                break;
            }
            case 'patientInitiatedChatsUpdated': {
                this.patientInitiatedChatsUpdated(message);
                break;
            }
            case 'transferSuccessful': {
                this.transferSuccessful(message);
                break;
            }
            default:
                throw new Error(`Unhandled realtime doctor case: ${message.action}`);
        }
    }
    phoneConfirmation(message) {
        this.$rootScope.$emit('phoneConfirmation', message);
    }
    passwordChanged(message) {
        this.$rootScope.$emit('passwordChanged', message);
    }
    patientInitiatedChatsUpdated(message) {
        this.$rootScope.$emit('patientInitiatedChatsUpdated', message);
    }
    transferSuccessful(message) {
        this.$rootScope.$emit('transferSuccessful', message);
    }
    onLeave() {
        // noop
    }
    reset() {
        // noop
    }
}
